import React from "react"
import PropTypes from "prop-types"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

// Render an Icon to show the user that this cell is editable
const EditableIcon = ({ tooltipLabel, iconName, iconClassName }) => (
    <Tooltip
        label={tooltipLabel}
    >
        <Icon name={iconName} className={iconClassName} />
    </Tooltip>
)


EditableIcon.propTypes = {
    tooltipLabel: PropTypes.string,
    iconName: PropTypes.string,
    iconClassName: PropTypes.string,
}

EditableIcon.defaultProps = {
    tooltipLabel: 'This cell is editable',
    iconName: 'pencil',
    iconClassName: 'editable-icon',
}

export default EditableIcon
